import {
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import HelpDialogLayout, {
  BodyTypographies,
  ContentStack,
  HelpDialogLayoutProps,
  SectionStack,
} from "./HelpDialogLayout";

export interface CaffeineDialogProps extends HelpDialogLayoutProps {}
export default function CaffeineDialog(props: CaffeineDialogProps) {
  const caffeineData = [
    ["コーヒー", "60mg"],
    ["エナジードリンク", "32～300mg"],
    ["紅茶", "30mg"],
    ["玉露", "160mg"],
    ["緑茶・ほうじ茶・ウーロン茶・ジャスミン茶", "20mg"],
    ["玄米茶", "10mg"],
    ["コーラ", "10mg"],
    ["ココア", "14mg"],
    ["チョコレート", "7～21mg／25gあたり"],
  ];
  return (
    <HelpDialogLayout {...props}>
      <ContentStack>
        <SectionStack>
          <Typography variant="subtitle2">睡眠への影響</Typography>
          <BodyTypographies
            contents={[
              "カフェインには覚醒作用があり、スムーズな入眠を妨げます。利尿作用もあるため、途中でトイレに起きることにつながります。そのため、まず、夕方以降～夜のカフェイン摂取は控えるようにしましょう。",
              "",
              "より具体的には、遺伝的に個人差があると言われてはいますが、カフェインは覚醒効果が半分になるまでに2～8時間の長い時間がかかります。夕方には体内のカフェインを100mg以下に抑えないと睡眠の質へ悪影響があるとされているので、それらを考慮して就寝から逆算し、カフェインの摂取タイミング・量を見直してみましょう。",
            ]}
          />
        </SectionStack>
        <Stack>
          <Typography variant="subtitle2" sx={{ mb: 4 }}>
            カフェインが多いもの
          </Typography>
          <TableContainer
            sx={{
              borderRadius: 0,
              "& tr": {
                borderBottom: "1px solid #e0e0e0",
                "&:first-of-type": {
                  borderTop: "1px solid #e0e0e0",
                },
              },
              "& .MuiTableCell-root": {
                borderBottom: "none",
              },
              "& th.MuiTableCell-root": {
                px: 0,
                py: 2,
                width: "50%",
                backgroundColor: "#f6f5f4",
                "&:first-of-type": {
                  whiteSpace: "nowrap",
                },
                "&:not(:first-of-type) .MuiTypography-caption": {
                  borderLeft: "1px solid #e0e0e0",
                },
                "& .MuiTypography-caption": {
                  color: "#3d3d3d",
                  px: 2,
                },
              },
              "& td.MuiTableCell-root": {
                px: 2,
                py: 3,
                fontSize: "13px",
                verticalAlign: "top",
                "&:not(:first-of-type)": {
                  borderLeft: "1px solid #e0e0e0",
                },
              },
            }}
          >
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <Typography variant="caption">
                      飲み物・食べ物の種類
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="caption">
                      カフェインの量（100mL中）
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {caffeineData.map(([item, quantity], itemIndex) => (
                  // TODO: 本来はこのあたりのTypographyにvariant="body3"を使いたい
                  <TableRow key={itemIndex}>
                    <TableCell>
                      <Typography sx={{ fontSize: "13px" }}>{item}</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography sx={{ fontSize: "13px" }}>
                        {quantity}
                      </Typography>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Stack>
        <SectionStack>
          <Typography variant="subtitle2">
            カフェインが少ない／含まれない
          </Typography>
          <BodyTypographies
            contents={[
              "麦茶、昆布茶、ごぼう茶、そば茶、はと麦茶、コーン茶、黒豆茶、たんぽぽ茶、デカフェ飲料、ルイボスティー、水、炭酸水、牛乳",
            ]}
          />
        </SectionStack>
      </ContentStack>
    </HelpDialogLayout>
  );
}
